import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { fetch_company_setting_preferences_data, update_settings_action } from '../../store/action/settings.action'
import { ServiceUrlConstants } from '../../constants/service-url-constants'
import { map } from 'rxjs'
import { CompanySettingPreferencesAPIModel } from '../../models/api.model'

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  dispatchFetchCompanySettingPreferencesData(referenceId: string, referenceType: string) {
    this.appState.dispatch(fetch_company_setting_preferences_data({ referenceId, referenceType }))
  }

  invokeFetchCompanySettingPreferences(referenceId: string, referenceType: string) {
    const endPoint = `${ServiceUrlConstants.API_SETTINGS}?referenceId=${referenceId}&referenceType=${referenceType}`
    return this.webservice
      .get(endPoint)
      .pipe(map((companySettingPreferences: CompanySettingPreferencesAPIModel) => companySettingPreferences))
  }

  dispatchUpdateSettings(
    referenceId: string,
    referenceType: string,
    settingsType: string,
    companySettingPreferences: CompanySettingPreferencesAPIModel
  ) {
    this.appState.dispatch(
      update_settings_action({ referenceId, referenceType, settingsType, companySettingPreferences })
    )
  }

  callUpdateSettingsApi = (
    referenceId: string,
    referenceType: string,
    settingsType: string,
    companySettingPreferences: CompanySettingPreferencesAPIModel
  ) => {
    const endPoint = `${ServiceUrlConstants.API_SETTINGS}?referenceId=${referenceId}&referenceType=${referenceType}&settingsType=${settingsType}`
    return this.webservice
      .put(endPoint, companySettingPreferences)
      .pipe(map((data: CompanySettingPreferencesAPIModel) => data))
  }
}
